export const LONDON_UIC = '7015400';
export const EBBSFLEET_UIC = '7015440';
export const ASHFORD_UIC = '7054660';
export const PARIS_UIC = '8727100';
export const CALAIS_UIC = '8728107';
export const LILLE_UIC = '8722326';
export const DISNEY_UIC = '8711184';
export const BRUSSEL_UIC = '8814001';
export const AMSTERDAM_UIC = '8400058';

// Eurostar red
export const ROTERDAM_UIC = '8400530';
export const SCHIPHOL_UIC = '8400561';
export const ANTWERPEN_UIC = '8821006';
export const LIEGE_UIC = '8841004';
export const AACHEN_UIC = '8015345';
export const COLOGNE_UIC = '8015458';
export const DORTMUND_UIC = '8010053';
export const DUISBURG_UIC = '8010316';
export const DUSSELDORF_AIRPORT_UIC = '8039904';
export const DUSSELDORF_UIC = '8008094';
export const ESSEN_UIC = '8010184';
